// gettheflockout.my serves this same app, but as its own site: the homepage
// at "/", no Dijon branding. On dijondreams.com it lives under /flockout.
export const FLOCKOUT_HOST = /(^|\.)gettheflockout\.my$/.test(window.location.hostname);

const ROOT = FLOCKOUT_HOST ? "" : "/flockout";
export const FO_HOME = ROOT || "/";
export const FO_ABOUT = `${ROOT}/about`;
export const FO_MAP = `${ROOT}/map`;
